import { toast } from "react-toastify";
import { Meta } from "../../../services/Meta";
import { useContextSite } from "../../../context/Context";
import { useNavigate } from "react-router-dom";

export const useGoalsRegister = () => {
  const { setIsLoad } = useContextSite();
  const navigate = useNavigate();

  function handleSubmit(data) {
    setIsLoad(true);

    return Meta.post(data)
      .then(() => {
        toast.success("Meta cadastrada com sucesso");
        navigate("/configuracoes/metas");
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  return { handleSubmit };
};
